import { Card, Dropdown, Grid } from "semantic-ui-react";
import { convertToDollar, convertToMinFraction } from "../../../Helpers";
import { IHomeProjectsObj } from "../../interfaces/Borrower";

interface IBWProjectCard {
  project: IHomeProjectsObj;
  index: string | number;
}

const BWProjectCard = ({project, index}: IBWProjectCard) => {
  return (
    <Card key={"project-content-card-" + index}>
      <Card.Content>
        <Grid columns={2}>
          <Grid.Row className="card-grid-row">
            <Grid.Column><div className="card-grid-loan-number">{project.loanNumber}</div> {project.projectName}</Grid.Column>
            <Grid.Column>
              <div className="card-grid-divide-column">
                <p>{project.isActive ? "Active" : "Inactive"}</p> 
                <Dropdown key="card-dropdown" className="icon landing-page-card-header-icon" icon="ellipsis vertical" pointing="top right">
                  <Dropdown.Menu key="card-menu" className="borrower-home borrower-projects-transform">
                  {/* TODO: functionality for downloads */}
                    <Dropdown.Item key="download-draw-management" onClick={() => console.log("Download Draw Management")}>Download Draw Management</Dropdown.Item>
                    <Dropdown.Item key="download-borrower-statement" onClick={() => console.log("Download Borrower Statement")}>Download Borrower Statement</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="card-grid-row grid-color-row">
            <Grid.Column>Original Loan: {convertToDollar(project.loanAmountOriginal)}</Grid.Column>
            <Grid.Column>Current Loan: {convertToDollar(project.loanAmountCurrent)}</Grid.Column>
          </Grid.Row>
          <Grid.Row className="card-grid-row">
          <Grid.Column>Interest Rate: {`${convertToMinFraction(project.interestRateCurrent, 3, 3)} %`}</Grid.Column>
            <Grid.Column>Maturity Date: {new Date(project.maturityDateCurrent).toLocaleDateString()}</Grid.Column>
          </Grid.Row>
          <Grid.Row className="card-grid-row grid-color-row">
          <Grid.Column>Interest Reserve: {convertToDollar(project.interestReserveCurrent)}</Grid.Column>
            <Grid.Column>Budget Balance: {convertToDollar(project.remainingBudget)}</Grid.Column>
          </Grid.Row>
          <Grid.Row className="card-grid-row">
            <Grid.Column>Last Owing: {convertToDollar(project.previousOwing)}</Grid.Column>
            <Grid.Column>Total Owing: {convertToDollar(project.totalOwingAmount)}</Grid.Column>
          </Grid.Row>
          <Grid.Row className="card-grid-row grid-color-row">
            <Grid.Column>
            Loan Officer:<a href={`mailto: ${project.loanOfficerEmail}`} style={{ textDecoration: "underline" }}>{project.loanOfficer}</a>
            </Grid.Column>
            <Grid.Column>
              Servicing Rep:<a href={`mailto: ${project.portfolioManagerEmail}`} style={{ textDecoration: "underline" }}>{project.portfolioManager}</a>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card.Content>
    </Card>
  );
};

export default BWProjectCard;